import ImageWithFallback from '@/globalComponents/image';
import Button from '@/shared/Button';
import Div from '@/shared/Div';
import React, { memo } from 'react';
import Map from '../Map';

const Banner = ({ image, ctas }: any) => {
  return (
    <Div className="relative">
      <ImageWithFallback
        src={image.data.attributes.url}
        alt={image.data.attributes.name}
        width={image.data.attributes.width}
        height={image.data.attributes.height}
      />

      <Map
        className="absolute left-6 top-1/2"
        list={ctas}
        render={({ label, href, id }) => (
          <Button key={id} href={href} theme="secondary" size="xs">
            {label}
          </Button>
        )}
      />
    </Div>
  );
};

export default memo(Banner);
